import UINotifiButton from 'components/shared/notifi/UINotifiButton';
import React from 'react';
import { useBCMSModal, useBCMSContext } from "bcms-react";
import CustomModal, { CustomModalContent, CustomModalFooter } from '../..';
import "./styles.css";
import { ContactInfo } from 'model';

/**
 * @function DeleteEmailModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the DeletePhoneModal
 */
export default function DeleteEmailModal(props) {
  const { info, refresh } = props.data ?? {};

  const { close } = useBCMSModal();
  const globalController = useBCMSContext();

  const deleteContactInfo = evt => {
    ContactInfo.setNextContactInfoInArrayAsPrimary(info, globalController);

    close("DeleteEmailModal");
    refresh();
  }
  const closeModal = evt => { close("DeleteEmailModal"); }

  return (
    <CustomModal title="Delete Email" id="DeleteEmailModal" className="delete-email-modal mobile-view-modal">
      <CustomModalContent>
        <p>Are you sure you want to delete the Email '{ info.value }'?</p>
      </CustomModalContent>
      <CustomModalFooter>
        <UINotifiButton text="Cancel" className="ui-notifi-secondary-modal-button" onClick={ closeModal } />
        <UINotifiButton text="Delete" onClick={ deleteContactInfo } />
      </CustomModalFooter>
    </CustomModal>
  );
}
